<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>{{title}}</strong></v-card-title>
          </v-layout>
          <br />
          <v-layout align-center>
            <v-flex xs12 sm12 md2 lg2>
              <div class='ml-10'><p align='right'>รหัสตารางราคาสินค้า : </p></div>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4>
              <div> <v-text-field solo class='ml-4' dense v-model="grouppriceno" :rules="[v => !!v || 'กรุณากรอกรหัสตารางราคาสินค้า']"></v-text-field></div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 sm12 md2 lg2>
              <div class='ml-10 mt-2'><p align='right'>ชื่อตารางราคาสินค้า :</p></div>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4>
              <div> <v-text-field solo class='ml-4' dense required :rules="[v => !!v || 'กรุณากรอกชื่อตารางราคาสินค้า']" v-model="grouppricename"></v-text-field></div>
            </v-flex>
          </v-layout>

          <v-layout row wrap justify-end>
            <!-- <div class='flex-grow-1'></div> -->
            <v-flex xs11 sm5 md3 lg3>
              <v-btn class="mx-2" outlined color="indigo lighten-2" @click="openpriceproductmodal('')">
                <v-icon>mdi-plus</v-icon>&nbsp;
                เพิ่ม/แก้ไข
              </v-btn>
            </v-flex>
          </v-layout>
          <br />
        <v-layout justify-center>
          <v-flex xs12 sm9 md9 lg9>
          <v-data-table
            :headers="headers"
            :items="productdatas"
            :items-per-page="10"
            class="elevation-3"
            :loading="loading"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td v-on:click="checkeditem(item, 1)">
                    <v-checkbox class="justify-center" v-model="item.promotion" :disabled="item.disabled" color="pink lighten-2" v-on:change="selectpromotion(item)"></v-checkbox>
                  </td>
                  <td v-on:click="checkeditem(item)">{{ item.product_no }}</td>
                  <td v-on:click="checkeditem(item)">
                    <v-container class="con">
                    <v-img
                      class="white--text align-center"
                      style="height:100px; width:130px;"
                      :src="item.image"
                      v-if="item.image"
                    ></v-img></v-container></td>
                  <td v-on:click="checkeditem(item)">{{ item.name }}</td>
                  <td v-on:click="checkeditem(item)">{{ item.price }}</td>
                  <td v-on:click="checkeditem(item)">{{ item.type }}</td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <v-layout justify-end>
          <div class="flex-grow-1"></div>

          <v-btn color="pink" style="margin-right: 5px" outlined @click="cancel()">ยกเลิก</v-btn>
          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
          <v-flex xs1 sm1 md1 lg1></v-flex>
        </v-layout>
        <br />
        <br />
        <Selectproductmodal />
        </v-card>
      </v-flex>
    </v-layout>
    <div class="vld-parent">
      <loading :active.sync="isLoading" is-full-page></loading>
    </div>
  </v-container>
</template>

<script>
import Selectproductmodal from '@/components/Selectproductmodal'
import axios from 'axios'
import swal from 'sweetalert'
import { sync } from 'vuex-pathify'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import numeral from 'numeral'
export default {
  components: {
    Selectproductmodal,
    Loading
  },
  data: () => ({
    loading: false,
    title: 'เพิ่มตารางราคาสินค้า',
    grouppriceid: '',
    grouppriceno: '',
    grouppricename: '',
    headers: [
      { text: 'โปรโมชัน', align: 'center', sortable: false },
      { text: 'รหัสซื้อขาย', align: 'center', sortable: false, value: 'product_no' },
      { text: 'รูปสินค้า', align: 'center', sortable: false, value: 'image' },
      { text: 'ชื่อสินค้า', align: 'center', sortable: false, value: 'name' },
      { text: 'ราคา', align: 'center', sortable: false, value: 'price' },
      { text: 'ประเภท', align: 'center', sortable: false, value: 'type' }
      // { text: 'แก้ไข/ลบ', value: 'action', sortable: false, align: 'center' }
    ],
    productdatas: [],
    isedit: false,
    selected: [],
    dis: false,
    isLoading: false
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin' || this.$cookies.get('status') === 'admin') {
        if (window.location.pathname.split('/')[2] || this.currentgrouppricedata) {
          this.getdata()
        }
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async save () {
      try {
        if (this.grouppriceno.length > 0 && this.grouppricename.length > 0 && this.productdatas.length !== 0) {
          this.isLoading = true
          let productitems = this.productdatas.map(product => {
            return {
              product_id: product._id,
              price: product.price,
              promotion: product.promotion
            }
          })
          let tempdata = { groupprice_no: this.grouppriceno, name: this.grouppricename, productitems: productitems }
          if (this.grouppriceid !== '') {
            await axios.put(`${process.env.VUE_APP_API}/groupprice/edit/${this.grouppriceid}`, tempdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            await this.getdata()
            this.isLoading = false
            await swal(`บันทึกการแก้ไขตารางราคาสินค้าเรียบร้อย`, {
              icon: 'success',
              buttons: 'ตกลง'
            })
            this.$router.push(`/manageproductprices`)
          } else {
            await axios.post(`${process.env.VUE_APP_API}/groupprice/create`, tempdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            this.currentgrouppricedata = ''
            this.isLoading = false
            await swal(`บันทึกตารางราคาสินค้าเรียบร้อย`, {
              icon: 'success',
              buttons: 'ตกลง'
            })
            this.$router.push(`/manageproductprices`)
          }
          this.currentgrouppricedata = ''
        // this.$router.push('/manageproductprices')
        } else if (this.grouppriceno.length === 0) {
          await swal({
            title: `กรุณากรอกรหัสตารางราคาสินค้า`,
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        } else if (this.grouppricename.length === 0) {
          await swal({
            title: `กรุณากรอกชื่อตารางราคาสินค้า`,
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        } else if (this.productdatas.length === 0) {
          await swal({
            title: `กรุณากรอกเลือกสินค้า`,
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        } else {
          await swal({
            title: `กรุณากรอกข้อมูลให้ครบถ้วน`,
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        }
      } catch (error) {
        await swal({
          title: 'ระบบผิดพลาด',
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          dangerMode: true,
          buttons: 'ตกลง'
        })
      }
    },
    cancel () {
      this.currentgrouppricedata = ''
      this.$router.push('/manageproductprices')
    },
    async getdata () {
      try {
        let currentgroupprice = window.location.pathname.split('/')[2]
        if (currentgroupprice) {
          this.loading = true
          this.title = 'รายละเอียดตารางราคาสินค้า'
          let currentgroupprice = window.location.pathname.split('/')[2]
          let { data } = await axios.get(`${process.env.VUE_APP_API}/groupprice/get/${currentgroupprice}`, {
            headers: {
              Authorization: this.$cookies.get('token')
            }
          })
          this.grouppriceid = data._id
          this.grouppriceno = data.groupprice_no
          this.grouppricename = data.name
          this.productdatas = data.productitems.map(pd => {
            pd.image = pd.image ? `${process.env.VUE_APP_API}${pd.image}` : ''
            pd.price = numeral(pd.price).format('0,0.00')
            return { ...pd }
          })
          this.productdatas.forEach(pd => { if (pd.promotion) { this.selectpromotion(pd) } })
          this.isedit = true
          this.loading = false
        }
      } catch (error) {
        this.loading = false
      }
    },
    async setdata () {
      this.productdatas = (JSON.parse(this.currentgrouppricedata)).map(pd => {
        pd.price = numeral(pd.price).format('0,0.00')
        return { ...pd }
      })
    },
    openpriceproductmodal (id) {
      this.selectproductmodal = true
      this.currentgrouppricedata = JSON.stringify(this.productdatas)
    },
    async deleteproduct (id) {
      try {
        let confirmsel = confirm(`Sure to delete product id: ${id} ?`)
        if (confirmsel) {
          await axios.delete(`${process.env.VUE_APP_API}/product/delete/${id}`, {
            headers: {
              Authorization: this.$cookies.get('token')
            }
          })
          this.getdata()
        }
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    selectpromotion (item) {
      let chk = this.selected.find(sel => sel._id === item._id)
      if (chk) {
        this.selected.splice(this.selected.indexOf(chk), 1)
      } else {
        if (this.selected.length < 6) {
          this.selected.push(item)
        } else if (this.selected.length === 6) {
          const elementshift = this.selected.shift()
          this.productdatas[this.productdatas.indexOf(elementshift)].promotion = false
          this.selected.push(item)
        }
      }

      if (this.selected.length === 6) {
        this.productdatas.map(pd => {
          pd.disabled = !pd.promotion
        })
      } else {
        this.productdatas.map(pd => {
          pd.disabled = false
        })
      }
    },
    async checkeditem (item, mode) {
      if (item.disabled && !item.promotion) {
        await swal({
          title: `สามารถเลือกสินค้าโปรโมชันได้เพียง 6 สินค้า`,
          icon: 'warning',
          dangerMode: true,
          buttons: 'ตกลง'
        })
      } else if (mode !== 1) {
        this.productdatas = await this.productdatas.map(pd => {
          pd.promotion = pd._id === item._id ? !pd.promotion : pd.promotion
          return { ...pd }
        })
        this.selectpromotion(item)
      }
    }
  },
  computed: {
    selectproductmodal: sync('selectproductmodal'),
    currentgrouppricedata: sync('currentgrouppricedata')
  },
  watch: {
    currentgrouppricedata () {
      this.setdata()
    }
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
p {
  font-family: 'Kanit';
  font-weight: bold;
}
.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}
.v-text-field {
  font-family: 'Kanit';
}
.v-data-table {
  font-family: 'Kanit';
}
</style>
